import { Workbook } from "exceljs";
import {
  excelHelper,
  fileHelper,
  formatHelper,
} from "../../../../common/helpers";
/**
 *
 * @param {any[]} quotations
 * @returns {Workbook}
 */
export const exportExcel = async (quotations) => {
  quotations.forEach((quotation, index) => {
    quotation.order = index + 1;
    quotation.customerName = `${quotation.Customer.name} ${quotation.Customer.lastname}`;
    quotation.expirationDateFormat = formatHelper.toDateDDMMYYY(
      quotation.expirationDate
    );
  });

  const json = excelHelper.jsonToJson(
    [quotations],
    [
      {
        name: "COTIZACIONES",
        props: [
          {
            inValue: "order",
            outValue: "",
          },
          {
            inValue: "code",
            outValue: "CODIGO",
          },
          {
            inValue: "customerName",
            outValue: "CLIENTE",
          },
          {
            inValue: "totalPrice",
            outValue: "PRECIO TOTAL",
          },
          {
            inValue: "discount",
            outValue: "DESCUENTO",
          },
          {
            inValue: "totalPriceDiscounted",
            outValue: "PRECIO TOTAL DESCONTADO",
          },
          {
            inValue: "expirationDateFormat",
            outValue: "FECHA DE EXPIRACION",
          },
        ],
      },
    ]
  );
  const workbook = excelHelper.jsonToExcelJs(json);
  const fileName = getFileName();
  const blob = await excelHelper.workbookToBlob(workbook);
  fileHelper.downloadBlob(blob, fileName);
};

const getFileName = () => {
  return (
    formatHelper.toDateYYMMDD(new Date().toUTCString()) +
    "_reporte-general-cotizaciones.xlsx"
  );
};



// WEBPACK FOOTER //
// ./src/scenes/Administration/Quotation/QuotationList/excel.js